export const isLoggedIn = (state: WebOrder.State) =>
  state.flipdish.Customer && state.flipdish.Customer.status === 'success';

//   export const getLoginError = (state: WebOrder.State) =>
//   state.flipdish.Customer && state.flipdish.Customer.status === 'error';

export const getUser = (state: WebOrder.State) =>
  state.flipdish.Customer && state.flipdish.Customer.status === 'success'
    ? state.flipdish.Customer.data
    : undefined;
